﻿import type { NotificationItem } from "@/lib/api";

const typeConfig: Record<NotificationItem["type"], { icon: string; color: string; bg: string; priority: "alta" | "media" | "baja" }> = {
  error: { icon: "ri-error-warning-line", color: "text-red-600", bg: "bg-red-100", priority: "alta" },
  warning: { icon: "ri-alert-line", color: "text-amber-600", bg: "bg-amber-100", priority: "media" },
  success: { icon: "ri-checkbox-circle-line", color: "text-emerald-600", bg: "bg-emerald-100", priority: "baja" },
  info: { icon: "ri-information-line", color: "text-blue-600", bg: "bg-blue-100", priority: "baja" },
};

const priorityBadge: Record<"alta" | "media" | "baja", string> = {
  alta: "bg-red-100 text-red-700",
  media: "bg-amber-100 text-amber-700",
  baja: "bg-gray-100 text-gray-600",
};

interface AlertasPanelProps {
  items: NotificationItem[];
}

export default function AlertasPanel({ items }: AlertasPanelProps) {
  return (
    <div className="bg-white rounded-xl border border-gray-100 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold text-gray-800">Alertas Operativas</h3>
        <span className="text-xs text-blue-600">{items.length} activas</span>
      </div>

      {items.length === 0 ? (
        <div className="p-6 text-sm text-gray-500 bg-gray-50 rounded-lg">Sin alertas activas.</div>
      ) : (
        <div className="space-y-3">
          {items.map((item) => {
            const cfg = typeConfig[item.type] ?? typeConfig.info;
            return (
              <div key={item.key} className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors">
                <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${cfg.bg}`}>
                  <i className={`${cfg.icon} text-sm ${cfg.color}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-700 leading-snug">{item.title}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{item.description}</p>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${priorityBadge[cfg.priority]}`}>
                  {cfg.priority}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
